import React, { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css';
import { useInView } from 'react-intersection-observer';
import '../styles/Divisions.css';

const divisions = [
  { name: 'Akij Textile Mills Ltd', image: 'atmlc.jpg', size: 'tall' },
  { name: 'Akij Bakers Ltd', image: 'ablc.jpg', size: 'medium' },
  { name: 'Akij Flour Mills Ltd', image: 'afmlc.jpg', size: 'tall' },
  { name: 'Akij Printing & Packages Ltd', image: 'applc.jpg', size: 'medium' },
  { name: 'Akij Textile Mills Ltd', image: 'atmld.jpg', size: 'medium' },
  { name: 'Akij Bakers Ltd', image: 'abld.jpg', size: 'tall' },
  { name: 'Akij Flour Mills Ltd', image: 'afmld.jpg', size: 'medium' },
  { name: 'Akij Printing & Packages Ltd', image: 'appld.jpg', size: 'tall' },
];

const breakpointColumnsObj = {
  default: 4,
  1100: 3,
  700: 2,
  500: 1
};

function Divisions() {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2
  });

  const [animateKey, setAnimateKey] = useState(0);

  useEffect(() => {
    if (inView) {
      setAnimateKey((prev) => prev + 1);
    }
  }, [inView]);

  return (
    <section className="divisions-section" id="businesses" ref={ref}>
      <h2 className="section-title">OUR DIVERSE BUSINESSES</h2>
      <div className="image-card">
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {divisions.map((div, index) => (
            <div
              className={`division-card ${div.size} wave-effect`}
              key={`${animateKey}-${index}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="image-container">
                <img
                  src={require(`../Assets/Images/${div.image}`)}
                  alt={div.name}
                  className="division-img"
                />
              </div>
              <div className="overlay">
                <h3>{div.name}</h3>
              </div>
            </div>
          ))}
        </Masonry>
      </div>
    </section>
  );
}

export default Divisions;
